import { DataModel } from "common/models/utility-models/base-model"

export class NotificationModel extends DataModel {
  announcement_datetime: any = ""
  template_id: any = "";
  send_to: any = ''
  content: any = ''
  batch_id: any = null
  branch_id: any = ''
  group_id: any = ''
  east: any = ''
  west: any = ''
  north: any = ''
  south: any = ''
  student_ids: any = ''
  announcement_type: any = ''
  announcement_mode: any = "email"
  announcement_id: any = ""
  totalStudentCount: any = ''
  region: any = ""
  time: any;
  submittedFrom: any = "notification";
}

export class notificationDetailsForm {
  announcement_datetime: "";
  template_id: "";
  send_to: "";
  content: "";
  batch_id: "";
  branch_id: "";
  group_id: "";
  east: "";
  west: "";
  north: "";
  south: "";
  student_ids: "";
  announcement_type: "";
  announcement_mode: "email"
  region: []


}